// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function useSidebar(param) {
  var match = React.useState(function () {
        
      });
  var state = match[0];
  var sidebarCmp = state !== undefined ? state : /* EditOrder */0;
  return [
          sidebarCmp,
          match[1]
        ];
}

export {
  useSidebar ,
  
}
/* react Not a pure module */
